/* TODO: Style active header and hide inactive sections */

:host {
  display: block;
}

[role='tablist'] {
  margin: 0;
  padding: 0;
}

.content-area:not(:target) {
  display: none;
}

.heading {
  background-color: var(--color-off-white);
  float: left;
  list-style: none;
  border-right: 2px solid #fff;
}

.heading-link {
  padding: 14px 20px;
  display: inline-block;
  min-width: 150px;
  color: var(--color-link-blue);
  font-weight: var(--font-weight-bold);
  text-decoration: none;
}
.heading:hover .heading-link {
  color: #000;
}

.content {
  background-color: var(--color-off-white);
  border-top: 1px solid var(--color-dark-gray);
  padding: 20px;
  clear: both;
}
